import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { AppBarCMS } from '../../../../basic';
import { isUndefined } from 'lodash';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { SensorsAttributeForm } from './SensorsAttributeForm.jsx';
import {
  useGetSensorAttributeDetailQuery,
  useSaveSensorAttributeMutation,
} from '../../../../../redux/services/sensorAttributes';
import { Spinner } from '../../../../common';
import { useGetAttributeUnitsQuery } from '../../../../../redux/services/attributeUnits';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import {
  isAttributeKeyDefault,
  makeSensorAttributeInitials,
} from '../../../../../utils/helpers/CommonHelper';

export function SensorsAttributesEditPage() {
  const { t } = useTranslation();
  const { sensorId, attributeId } = useParams();
  const navigate = useNavigate();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const isCreate = isUndefined(attributeId);

  const { data: attribute, isLoading } = useGetSensorAttributeDetailQuery(
    { sensorId, attributeId },
    { skip: isCreate },
  );

  const { data: units, isLoading: isLoadingUnits } =
    useGetAttributeUnitsQuery();

  const [saveSensorAttribute, { isSuccess }] = useSaveSensorAttributeMutation();

  useEffect(() => {
    if (isSuccess) {
      showSaveSuccess();
      navigate(routes.cmsMeteoStationSensorsAttributes(sensorId));
    }
  }, [isSuccess]);

  const { isIconDisabled, initials } = useMemo(() => {
    if (isUndefined(attribute)) {
      return { isIconDisabled: false, initials: {} };
    }

    return {
      isIconDisabled: isAttributeKeyDefault(attribute.key),
      initials: makeSensorAttributeInitials(attribute),
    };
  }, [attribute]);

  return (!isCreate && isLoading) || isLoadingUnits ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={isCreate ? t('Nový atribút') : t('Úprava atribútu')}
        backUrl={routes.cmsMeteoStationSensorsAttributes(sensorId)}
        backUrlTooltip={t('Správa atribútov senzora')}
      />

      <div style={{ margin: '10px' }}>
        <SensorsAttributeForm
          units={units}
          isCreate={isCreate}
          isIconDisabled={isIconDisabled}
          initials={initials}
          onSubmit={(values) => {
            saveSensorAttribute({ sensorId, attributeId, values });
          }}
        />
      </div>
    </>
  );
}

export default SensorsAttributesEditPage;
